export default __webpack_public_path__ + "static/media/logo-ismsf.fb588910.jpg";